import React, { useRef, useEffect } from "react";
import CustomDatePicker from "./DateInput";
import ButtonWithText from "./Button";
import { POPUP_CONTENTS } from "app/popleads/modules/extension/utils/constants";
import { useExtensionContext } from "app/popleads/modules/extension/ExtensionContext";
import styled from "styled-components";

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const StyledCustomDatePicker = styled(CustomDatePicker)`
    input {
        caret-color: transparent;
    }
`;

const EditableDateField = ({ value, onChange, highlightedDates }) => {
    const datePickerRef = useRef();

    const handleIconClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.setOpen(true);
        }
    };

    return (
        <StyledCustomDatePicker
            highlightedDates={highlightedDates}
            leftIcon={"calendar"}
            value={value}
            onChange={(date) => {
                onChange(date);
            }}
            variant="unstyled"
            componentVariant={"l3rnTech"}
            ref={datePickerRef}
            leftIconClick={handleIconClick}
            showMonthYearDropdown={true}
        />
    );
};

const DateHeader = ({ highlightedDates }) => {
    const { selectedDate, setState } = useExtensionContext();

    useEffect(() => {
        return () => {
            setState({ selectedDate: new Date() });
        };
    }, []);

    const handleDateChange = (date) => {
        setState({ selectedDate: date });
    };

    return (
        <Wrapper>
            <div style={{ flex: 1 }}>
                <EditableDateField
                    value={selectedDate}
                    onChange={handleDateChange}
                    highlightedDates={highlightedDates}
                />
            </div>
            <ButtonWithText
                onClick={() => {
                    setState({
                        popupContent: POPUP_CONTENTS.NEW_TASK,
                        popupIsOpen: true,
                        taskPage: true,
                        editMode: false,
                    });
                }}
                buttonStyle="default"
                icon="add"
                iconType="material"
                variant="l3rnTech"
                type="default"
                size="circle"
            />
        </Wrapper>
    );
};

export default DateHeader;
